import { InventoryAdapter, type InventoryContext, type Sales, type Stock } from "@agapi/mlc-core";

/**
 * Adapter class for Brink Shop client-side operations
 */
class BrinkInventoryClientAdapter extends InventoryAdapter<any> {
  constructor() {
    super({});
  }

  /**
   * Validates that the adapter is being used in a client-side environment
   * @throws Error if fetch is not available
   */
  private validateOnClientSide() {
    if (!fetch) {
      throw new Error("BrinkShopClientAdapter is only available in the browser.");
    }
  }

  async getStock(params: { sku: string; }, context: Pick<InventoryContext, 'languageCode' | 'countryCode'>): Promise<Stock> {
    this.validateOnClientSide();
    const { languageCode, countryCode } = context;
    return (await fetch(`/api/product/stock?languageCode=${languageCode}&countryCode=${countryCode}&sku=${params.sku}`)).json();
  }

  // TODO: move to a price adapter?
  async get30DaySales(params: { sku: string; }, context: Pick<InventoryContext, 'languageCode' | 'countryCode'>): Promise<Partial<Sales>> {
    this.validateOnClientSide();
    const { languageCode, countryCode } = context;
    return (await fetch(`/api/product/last-30-day-price?languageCode=${languageCode}&countryCode=${countryCode}&sku=${params.sku}`)).json();
  }
};

const INVENTORY = new BrinkInventoryClientAdapter();
export default INVENTORY;
